// src/components/FirebaseUploader.js
import React, { useRef, useState } from 'react';
import { BiUpload } from 'react-icons/bi';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../../utils/firebase';
import './FirebaseUploader.scss';
import { useToast } from "../../context/ToastContext";

const FirebaseUploader = ({ label = "Upload", existingUrl = "", onUploadComplete }) => {
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [documentUrl, setDocumentUrl] = useState(existingUrl);
  const [file, setFile] = useState(null);

  const fileInputRef = useRef(null);

  const { showToast } = useToast();

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      handleFileUpload(selectedFile);
    }
  };

  const handleFileUpload = (selectedFile) => {
    if (!selectedFile) return;

    setUploading(true);
    setUploadProgress(0);

    const storageRef = ref(storage, `files/${Date.now()}-${selectedFile.name}`);
    const uploadTask = uploadBytesResumable(storageRef, selectedFile);

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgress(progress);
      },
      (error) => {
        console.error('File upload failed:', error);
        setUploading(false);
        showToast("Upload Failed", "error");
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setDocumentUrl(downloadURL);
          setUploading(false);
          onUploadComplete(downloadURL);
        });
      }
    );
  };

  const handleCancelUpload = () => {
    setFile(null);
    setDocumentUrl('');
    setUploadProgress(0);
    setUploading(false);
    onUploadComplete('');
  };

  return (
    <div className="firebase-upload">
      <label className="upload-label">{label}</label>
      <div
        className="upload-document-container"
        onClick={handleUploadClick}
        role="button"
        tabIndex={0}
        onKeyPress={(e) => e.key === 'Enter' && handleUploadClick()}
      >
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: 'none' }}
          accept="image/*"
        />
        <div className="upload-icon-container">
          <BiUpload size={24} color="#0066cc" />
          <span>Click to upload</span>
        </div>
      </div>

      {uploading && (
        <div className="upload-progress">
          <div className="progress-bar">
            <div className="progress" style={{ width: `${uploadProgress}%` }} />
          </div>
          <span>{Math.round(uploadProgress)}% uploaded</span>
        </div>
      )}

      {documentUrl && !uploading && (
        // <div className="uploaded-file">
        //   <a href={documentUrl} target="_blank" rel="noopener noreferrer">
        //     {file ? file.name : 'View Uploaded Document'}
        //   </a>
        //   <button type="button" onClick={handleCancelUpload} className="cancel-upload-button">
        //     Delete
        //   </button>
        // </div>
        <div className="uploaded-file">
                <a
                  href={documentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {file ? file.name : "View Uploaded Document"}
                </a>
                <button
                  type="button"
                  onClick={handleCancelUpload}
                  className="cancel-upload-button"
                >
                  Delete Document
                </button>
              </div>
      )}
    </div>
  );
};

export default FirebaseUploader;
